import styled from 'styled-components';

export default styled.span`
	display    : block;
	text-align : center;
`;
